const integrateProductPreOrderData = async (productID) => {
    try {
      const product = await fetchProduct_PreOrder_data(
        "gid://shopify/Product/" + productID
      );
      console.log(product);
      // const sellingPlanID = product.sellingPlanGroups.nodes[0].sellingPlans.id;
      if (!product) return false;
      return {
        id: product.sellingPlanGroups.nodes[0].sellingPlans.nodes[0].id,
        name: product.sellingPlanGroups.nodes[0].sellingPlans.nodes[0].name,
      };
    } catch (error) {
      console.log("error in integrateProductPreOrderData() ===> ", error);
    }
  };
  
  const updateAddCartButtonContent = () => {
    try {
      const button = document.getElementById("AddToCart");
      const buttonContent = button.getElementsByClassName(
        "loader-button__text"
      )[0];
      buttonContent.innerHTML = "Pre-order";
  
      // create a new instance of 'MutationObserver' named 'observer',
      // passing it a callback function
      observer = new MutationObserver(function (mutationsList, observer) {
        console.log("mutationsList ===> ", mutationsList);
  
        if (buttonContent.innerHTML !== "Pre-order") {
          buttonContent.innerHTML = "Pre-order";
          observer.disconnect();
        } 
      });
  
      // call 'observe' on that MutationObserver instance,
      // passing it the element to observe, and the options object
      observer.observe(buttonContent, {
        characterData: false,
        childList: true,
        attributes: false,
      });
    } catch (error) {
      console.log("error in updateAddCartButtonContent() => ", error);
    }
  };
  const inputPreOrderDescription = (sellingPlanName) => {
    try {
      const pre_order_shipping_duration = document.getElementById(
        "pre-order_shipping-duration"
      );
      pre_order_shipping_duration.innerHTML = sellingPlanName;
      pre_order_shipping_duration.style.marginTop = "15px";
      pre_order_shipping_duration.style.marginBottom = "7px";
      document.getElementById("pre-order_hint").style.display = "block";
    } catch (error) {
      console.log("error in inputPreOrderDescription() => ", error);
    }
  };
  var sellingPlanID;
  if (document.location.href.includes("https://tuccilimited.com/product")) {
    integrateProductPreOrderData(productID_of_childStore).then((result) => {
      console.log(result);
      if (!result) return false;
      sellingPlanID = result.id;
      updateAddCartButtonContent();
      inputPreOrderDescription(result.name);
    });
  }
  